// * -------------------------------- NPM --------------------------------------
import React from 'react'

// * -------------------------------- COMPONENTS --------------------------------------
import { WithTranslation } from '../../../../../mvlabs-components-fe/types/base'
import { mvDate, TIME } from '../../../../../mvlabs-components-fe/functions/helpers/dateHelper'
import { useComponentsTranslation } from '../../../../../mvlabs-components-fe/services/translation'

// * -------------------------------- MODULE --------------------------------------
import { EmptySlot } from '../../../../types/emptySlot'
import { Info } from './ModalSlotDetail'
import Shift from '../../../../types/shift'
import Flex, { JustifyContent, StretchColumn } from '../../../../../mvlabs-components-fe/ui/components/Flex/Flex'
import TableProcessDetail from '../Table/TableProcessDetail'
import { SectionTitle } from '../../../../../mvlabs-components-fe/ui/components/Text/Title'

const EmptySlotDetail = (props: { slot: EmptySlot; shift: Shift } & WithTranslation) => {
  const { slot, shift } = props
  const translation = useComponentsTranslation()
  const { t, base } = props.translation

  return (
    <StretchColumn>
      <Flex justifyContent={JustifyContent.start}>
        <Info
          title={t(`${base}.name`)}
          text={slot.getDisplayName(translation)}
          date={`${mvDate.format(slot.from, TIME)} - ${mvDate.format(slot.to, TIME)}`}
          translation={{ t, base }}
        />
      </Flex>
      {/* process.isCurrentSlot() && */ (slot.allWarnings.length > 0 && (
        <div>
          <SectionTitle title={t(`${base}.listMachine`)} />
          <TableProcessDetail
            shift={shift}
            process={slot}
            mappingAssetRecipe={[]}
            translation={{ t, base }}
          />
        </div>
      )) ||
        null}
    </StretchColumn>
  )
}

export default EmptySlotDetail
